export default "__VITE_ASSET__DljQsgYV__"